const Sdata = [

    {
        id: 1,
        name: "React.js",
        imgsrc: "./Images/reactjs.svg"
    },

    {
        id: 2,
        name: "Next.js",
        imgsrc: "./Images/nextjs.svg"
    },

    {
        id: 3,
        name: "HTML",
        imgsrc: "./Images/w3_html5-icon.svg"
    },

    {
        id: 4,
        name: "Sass",
        imgsrc: "./Images/sass.svg"
    },
    {
        id: 5,
        name: "Bootstrap",
        imgsrc: "./Images/bootstrap.svg"
    },
    {
        id: 6,
        name: "Material UI",
        imgsrc: "./Images/mui.svg"
    },
    {
        id: 7,
        name: "CSS",
        imgsrc: "./Images/css.svg"
    },
    {
        id: 8,
        name: "JavaScript",
        imgsrc: "./Images/javascript.svg"
    },
    {
        id: 9,
        name: "TypeScript",
        imgsrc: "./Images/typescript.svg"
    },
    {
        id: 10,
        name: "Ant Design",
        imgsrc: "./Images/antd.svg"
    }

]

export default Sdata;